import React from 'react';

import classNames from 'classnames';

import { Action, CALL_RESCUE_TEST_STATUS } from '../constants';
import { useCallRescueMonitorContext } from '../context';

const Filter: React.FC = () => {
  const { state, dispatch } = useCallRescueMonitorContext();
  const { callRescueStatusFilter } = state;
  const isScheduledIncludes = callRescueStatusFilter.includes(CALL_RESCUE_TEST_STATUS.SCHEDULED);
  const isSCallingIncludes = callRescueStatusFilter.includes(CALL_RESCUE_TEST_STATUS.CALLING);
  const isRetryingIncludes = callRescueStatusFilter.includes(CALL_RESCUE_TEST_STATUS.RETRYING);
  const isSuccessIncludes = callRescueStatusFilter.includes(CALL_RESCUE_TEST_STATUS.SUCCESS);
  const isFailureIncludes = callRescueStatusFilter.includes(CALL_RESCUE_TEST_STATUS.FAILURE);

  const handleSetCallRescueFilter = (status: number) => () => {
    dispatch({
      type: Action.SET_CALL_RESCUE_STATUS_FILTER,
      callRescueStatus: status,
    });
  };

  return (
    <div className="sm:mx-0 flex flex-col mx-4 mt-4">
      <p className="text-gray-1.0 font-semibold">Filters:</p>
      <div className="sm:space-x-4 sm:space-y-0 flex flex-wrap flex-shrink-0 mt-1 space-x-2 space-y-1">
        <button
          type="button"
          className={classNames(
            'btn',
            isScheduledIncludes ? 'btn-primary' : 'btn-ghost border border-gray-1.0'
          )}
          onClick={handleSetCallRescueFilter(CALL_RESCUE_TEST_STATUS.SCHEDULED)}
          data-testid="scheduled-filter"
        >
          SCHEDULED
        </button>
        <button
          type="button"
          className={classNames(
            'btn',
            isSCallingIncludes ? 'btn-primary' : 'btn-ghost border border-gray-1.0'
          )}
          onClick={handleSetCallRescueFilter(CALL_RESCUE_TEST_STATUS.CALLING)}
          data-testid="calling-filter"
        >
          CALLING
        </button>
        <button
          type="button"
          className={classNames(
            'btn',
            isRetryingIncludes ? 'btn-primary' : 'btn-ghost border border-gray-1.0'
          )}
          onClick={handleSetCallRescueFilter(CALL_RESCUE_TEST_STATUS.RETRYING)}
          data-testid="retrying-filter"
        >
          RETRYING
        </button>
        <button
          type="button"
          className={classNames(
            'btn',
            isSuccessIncludes ? 'btn-primary' : 'btn-ghost border border-gray-1.0'
          )}
          onClick={handleSetCallRescueFilter(CALL_RESCUE_TEST_STATUS.SUCCESS)}
          data-testid="success-filter"
        >
          SUCCESS
        </button>
        <button
          type="button"
          className={classNames(
            'btn',
            isFailureIncludes ? 'btn-primary' : 'btn-ghost border border-gray-1.0'
          )}
          onClick={handleSetCallRescueFilter(CALL_RESCUE_TEST_STATUS.FAILURE)}
          data-testid="failure-filter"
        >
          FAILURE
        </button>
      </div>
    </div>
  );
};
export default Filter;
